// generated by genversion
export var version = '4.1.0';
//# sourceMappingURL=version.js.map